import React, {useEffect, useState} from "react";
import {epdAstralService} from "../../../../services";
import {Button, Col, Form, Icon, Input, Modal, notification, Row, Upload} from "antd";
import InputField from "../../../input-field";
import DividerBlock from "../../../divider-block";
import FieldBlock from "../../../field-block";
import i18n from "../../../../i18n";

export default function ModalRegisterApiAttorney({legalEntityName, legalEntityId, personId, personName, isShow, onCloseModal, setIsNeedUpdate}) {
  const [fieldsErrors, setFieldsErrors] = useState(null);
  const [attorney, setAttorney] = useState(null);

  const uploaderAttorney = {
    multiple: false,
    showUploadList: true,
    onRemove: () => {
      setAttorney(null);
    },
    beforeUpload: (file) => {
      setAttorney(file);
      return false;
    },
    listType: 'file'
  };

  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };
  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined") ? fieldsErrors[nameField][0] : null;
  };
  const registerApiAttorney = () => {
    epdAstralService.registerApiAttorney({legalEntityId, personId, attorney})
      .then(resp => {
        if (resp.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.registerApiAttorney'),
            description: resp.message,
          });
          onCloseModal(false);
          setIsNeedUpdate(true);
        } else if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
          notification.error({
            message: i18n.t('components.notification.titles.registerApiAttorney'),
            description: resp.message,
          });
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.registerApiAttorney'), description: err,
        });
      });
  }

  return (<Modal
      title={<div>{i18n.t('modals.modalRegisterApiAttorney.title')}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal(false);
      }}
      forceRender={true}
      footer={
        <Button htmlType="submit" key="submit" type="primary"
                style={bigButtonStyle}
                onClick={() => registerApiAttorney()}
        >{i18n.t('main.buttons.send')}</Button>
      }
    >
      <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
        <Col span={24}>
          <p>{i18n.t('modals.modalRegisterApiAttorney.fields.legalEntityName.title')}: {legalEntityName}</p>
          <p>{i18n.t('modals.modalRegisterApiAttorney.fields.personName.title')}: {personName}</p>
        </Col>
      </Row>
      <span className="divider-label" style={{align: 'left'}}>{i18n.t('modals.modalRegisterApiAttorney.divider.attorney')}</span>
      <DividerBlock />
      <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
        <Col lg={24} md={24} sm={24} xs={24}>
            <FieldBlock name="attorney" getErrors={getFieldErrors}>
                <Upload className="single-btn-upload" {...uploaderAttorney}>
                    <Button htmlType="button">
                      {i18n.t('modals.modalRegisterApiAttorney.buttons.attorney')}
                    </Button>
                </Upload>
            </FieldBlock>
        </Col>
      </Row>
    </Modal>
  )
}
